<template>
  <FormPage
    title="Новый прицеп"
    description="Создайте прицеп-исполнителя. Поля «Номер» и «VIN» обязательны."
  >
    <template #controls>
    </template>
    <TrailerForm @sendForm="onSubmit" @closeForm="onCancel" />
  </FormPage>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { createToaster } from '@meforma/vue-toaster'
import TrailerForm from '@/components/forms/TrailerForm.vue'

const toaster = createToaster()

export default {
  name: 'TrailerCreatePage',
  components: { TrailerForm },
  setup() {
    const router = useRouter()
    const store = useStore()

    const onSubmit = async ({ model, form }) => {
      const created = await store.dispatch('apiStorage/addItem', {
        model,
        form: { ...form, is_trailer: true },
      })
      if (!created) return
      toaster.success('Прицеп добавлен')
      const id = created.id || created.trailer?.id
      if (id != null) {
        router.push({ name: 'TrailerDetail', params: { id: String(id) } })
      } else {
        router.push({ name: 'TrailerList' })
      }
    }

    const onCancel = () => {
      router.push({ name: 'TrailerList' })
    }

    return { onSubmit, onCancel }
  },
}
</script>
